




import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'
import dataProxyService from '../services/data-proxy.service';
import { MarkaVozila } from '../services/BackendProxies';

@Component({})
export default class MarkeVozilaEditor extends Vue {
    markeVozila = [];
    @Prop() value!: string;
    @Prop({default: false}) invalid!: boolean;

    model = '';

    @Watch("value") onValueChange(value) {
        this.model = value;
    }

    @Watch("model") onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value: string) {
    }

    async created() {
        const marke = this.markeVozila = await dataProxyService.vratiMarkeVozila();
        marke.unshift(MarkaVozila.fromJS({id: '', naziv: '...'}));
        this.markeVozila = marke.map(mv => ({id: mv.id, text: mv.naziv}));
        this.model = this.value;
    }
}
